<template>
  <b-button v-bind="$attrs" :disabled="waiting" @click="$emit('click')">
    <slot v-if="!waiting"></slot>
    <template v-else>
      <b-spinner variant="light" small></b-spinner>
    </template>
  </b-button>
</template>

<script>
import { mapState } from "vuex"

export default {
  name: "ActionButton",
  computed: {
    ...mapState("user", ["waiting"]),
  }
}
</script>
